import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const strategyGuidanceChangeSchema = z.discriminatedUnion("target", [
  z.object({
    target: z.literal("guidance"),
    /** Offsets of `before` in the guidance the fix was written for. */
    start: z.number().int(),
    end: z.number().int(),
    before: z.string(),
    highlightStart: z.number().int(),
    highlightEnd: z.number().int(),
    after: z.string(),
  }),
  z.object({
    target: z.literal("supervisor"),
    before: z.string(),
    after: z.string(),
  }),
  z.object({
    target: z.literal("knowledgeEdit"),
    articleId: z.string(),
    articleTitle: z.string(),
    before: z.string(),
    after: z.string(),
  }),
  z.object({
    target: z.literal("knowledgeCreate"),
    title: z.string(),
    after: z.string(),
  }),
]);

export type StrategyGuidanceChangeWire = z.infer<
  typeof strategyGuidanceChangeSchema
>;

/** The changes the fix card offers for one issue; null when none could be written. */
export const draftShopperAgentStrategyGuidanceFix = {
  name: "draftShopperAgentStrategyGuidanceFix" as const,
  input: z.object({
    guidance: z.string(),
    mongoDiscountId: zExt.objectId().nullable(),
    issue: z.object({
      start: z.number().int(),
      end: z.number().int(),
      message: z.string(),
      kind: z.string().optional(),
    }),
  }),
  output: z.object({
    fix: z
      .object({
        /** "one" when the changes are alternatives. */
        choose: z.enum(["one", "any"]),
        changes: z.array(strategyGuidanceChangeSchema),
      })
      .nullable(),
  }),
};
